export const ACTIVE_COMMUNE_EXACT_TITLES = [
  'SOA',
  'MEIGANGA',
  'NKOLAFAMBA',
  'NITOUKOU',
  'MBANKOMO',
  'NGOUMOU',
  'ATOK',
  'BAFOUSSAM 3E',
  'LIMBE 3RD',
] as const

export const ACTIVE_COMMUNE_PREFIX_TITLES = ['EDEA', 'KRIBI'] as const

export function normalizeActiveCommuneTitle(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase()
}

export function isActiveCommuneTitle(value: string | null | undefined): boolean {
  const normalizedTitle = normalizeActiveCommuneTitle(value ?? '')
  if (!normalizedTitle) return false
  if (ACTIVE_COMMUNE_EXACT_TITLES.includes(normalizedTitle as typeof ACTIVE_COMMUNE_EXACT_TITLES[number])) {
    return true
  }
  return ACTIVE_COMMUNE_PREFIX_TITLES.some((prefix) => normalizedTitle.startsWith(prefix))
}

export function filterAllowedCommunes<T extends { cmnTitre?: string | null }>(communes: T[]): T[] {
  return communes.filter((commune) => isActiveCommuneTitle(commune.cmnTitre))
}

export function getFallbackActiveCommuneTitles(): string[] {
  return [...ACTIVE_COMMUNE_EXACT_TITLES, ...ACTIVE_COMMUNE_PREFIX_TITLES]
}
